/* Calmont Basis-Skripte: Reveal, Accordions (eins offen), Live-Status Support. */
(() => {
  // Reveal beim Hereinscrollen
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => {
    es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  const reveal = (root = document) => root.querySelectorAll('.cal-rv:not(.is-in)').forEach((el) => io ? io.observe(el) : el.classList.add('is-in'));

  // Accordions: in [data-cal-acc-single] bleibt nur einer offen
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    const g = d.closest('[data-cal-acc-single]');
    if (g) g.querySelectorAll('details[open]').forEach((x) => { if (x !== d) x.open = false; });
  }, true);

  // Support live: data-hours="1-5|9-13" (Wochentage 1=Mo … 7=So | Stunden), Zeitzone Europe/Berlin
  const support = (root = document) => root.querySelectorAll('[data-cal-support]').forEach((el) => {
    const [days, hrs] = (el.dataset.hours || '1-5|9-13').split('|');
    const [d0, d1] = days.split('-').map(Number); const [h0, h1] = hrs.split('-').map(Number);
    const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
    const wd = now.getDay() || 7; const h = now.getHours() + now.getMinutes() / 60;
    // Telefon pausiert (Theme-Einstellung „Telefon pausiert bis“): bis einschließlich Datum nicht erreichbar
    const pz = window.CalPhonePause; let paused = false;
    if (pz && /^\d{4}-\d{2}-\d{2}$/.test(pz.until)) { const ymd = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0'); paused = ymd <= pz.until; }
    if (paused) {
      el.classList.remove('is-on');
      const st0 = el.querySelector('[data-cal-support-status]');
      if (st0) { const [y, m, d] = pz.until.split('-').map(Number); const nx = new Date(y, m - 1, d + 1); st0.textContent = (pz.text || '').replace(/\{datum\}|\[datum\]/, nx.getDate() + '.' + (nx.getMonth() + 1) + '.'); }
      return;
    }
    const on = wd >= d0 && wd <= d1 && h >= h0 && h < h1;
    el.classList.toggle('is-on', on);
    const st = el.querySelector('[data-cal-support-status]');
    if (!st) return;
    if (on) { st.textContent = el.dataset.onText || 'Jetzt erreichbar'; return; }
    const next = (wd >= d0 && wd <= d1 && h < h0) ? `heute ab ${h0} Uhr` : ((wd >= d0 && wd < d1) ? `morgen ab ${h0} Uhr` : `Montag ab ${h0} Uhr`);
    st.textContent = (el.dataset.offText || 'Telefonisch wieder [next]').replace(/\{next\}|\[next\]/, next);
  });

  // Wechsel-Anzeige: [data-cal-rotate="4000"] mit [data-cal-rotate-item] + optional [data-cal-rotate-dot]
  const rotate = (root = document) => root.querySelectorAll('[data-cal-rotate]').forEach((el) => {
    if (el._calRot) return; el._calRot = true;
    const items = [...el.querySelectorAll('[data-cal-rotate-item]')]; const dots = [...el.querySelectorAll('[data-cal-rotate-dot]')];
    if (items.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const ms = Number(el.dataset.calRotate) || 4000; el.style.setProperty('--rot', ms + 'ms');
    let i = 0; let paused = false;
    el.addEventListener('mouseenter', () => { paused = true; }); el.addEventListener('mouseleave', () => { paused = false; });
    const show = (n) => { items.forEach((x, k) => x.classList.toggle('is-on', k === n)); dots.forEach((x, k) => { x.classList.remove('is-on'); if (k === n) { void x.offsetWidth; x.classList.add('is-on'); } }); };
    let timer;
    const restart = () => { clearInterval(timer); timer = setInterval(() => { if (!paused) { i = (i + 1) % items.length; show(i); } }, ms); };
    const go = (n) => { i = (n + items.length) % items.length; show(i); restart(); };
    // Wischen (Touch) und Tippen auf die Balken wechseln ebenfalls
    let x0 = null; let y0 = null;
    el.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; paused = true; }, { passive: true });
    el.addEventListener('touchend', (e) => {
      paused = false; if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0; const dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1));
    }, { passive: true });
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
    restart();
  });

  // Tabs: [data-cal-tabs] mit Buttons [data-cal-tab]; alle [data-cal-tab-panel] werden je Gruppe nach Index umgeschaltet
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cal-tab]'); if (!btn) return;
    const box = btn.closest('[data-cal-tabs]'); if (!box) return;
    const tabs = [...box.querySelectorAll('[data-cal-tab]')]; const n = tabs.indexOf(btn);
    tabs.forEach((t, k) => t.setAttribute('aria-selected', String(k === n)));
    btn.parentElement.style.setProperty('--i', n);
    const panels = [...box.querySelectorAll('[data-cal-tab-panel]')]; const per = panels.length / tabs.length;
    panels.forEach((p, k) => { p.hidden = (k % tabs.length) !== n; });
    if (per !== Math.round(per)) console.warn('[CAL] Tabs: Panel-Anzahl passt nicht');
  });

  const init = (root) => { reveal(root); support(root); rotate(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  // Theme-Editor: neu geladene Sections
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* Bewertungskarten: „Mehr lesen“ nur zeigen, wenn der Text gekürzt ist */
(() => {
  const check = () => document.querySelectorAll('.cal-rcard').forEach((c) => {
    const x = c.querySelector('.cal-rcard__x'); const b = c.querySelector('[data-rmore]');
    if (!x || !b || c.classList.contains('is-open')) return;
    b.hidden = x.scrollHeight <= x.clientHeight + 2;
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-rmore]'); if (!b) return;
    const c = b.closest('.cal-rcard'); const o = c.classList.toggle('is-open');
    b.textContent = o ? 'Weniger anzeigen' : 'Mehr lesen'; b.setAttribute('aria-expanded', String(o));
  });
  if (document.readyState !== 'loading') check(); else document.addEventListener('DOMContentLoaded', check);
  window.addEventListener('load', check);
  window.addEventListener('resize', () => { clearTimeout(window.__calRc); window.__calRc = setTimeout(check, 200); });
  document.addEventListener('shopify:section:load', check);

  // Siegel-Tooltip: ein schwebendes Element, im Bildschirm gehalten (mobil per Antippen)
  (() => {
    let pop = null; let cur = null;
    const hide = () => { if (!pop) return; pop.classList.remove('is-on'); if (cur) cur.closest('.cal-seals-mq')?.classList.remove('is-paused'); cur = null; };
    const show = (el) => {
      const tip = el.querySelector('.cal-seals__tip'); if (!tip) return;
      if (!pop) { pop = document.createElement('div'); pop.className = 'cal-seals-pop'; pop.setAttribute('aria-hidden', 'true'); document.body.append(pop); }
      cur = el; el.closest('.cal-seals-mq')?.classList.add('is-paused');
      pop.textContent = tip.textContent;
      const r = el.getBoundingClientRect(); const w = pop.offsetWidth; const h = pop.offsetHeight;
      const left = Math.max(12, Math.min(r.left + r.width / 2 - w / 2, innerWidth - w - 12));
      let top = r.top - h - 8; if (top < 8) top = r.bottom + 8;
      pop.style.left = left + 'px'; pop.style.top = top + 'px'; pop.classList.add('is-on');
    };
    document.documentElement.classList.add('cal-tips-js');
    document.addEventListener('mouseover', (e) => { const el = e.target.closest?.('.cal-seals__i'); if (el && el !== cur) show(el); else if (!el && cur && !cur.contains(document.activeElement)) hide(); });
    document.addEventListener('focusin', (e) => { const el = e.target.closest?.('.cal-seals__i'); if (el) show(el); else hide(); });
    document.addEventListener('click', (e) => { const el = e.target.closest?.('.cal-seals__i'); if (el) { if (el.closest('a')) e.preventDefault(); show(el); } else hide(); });
    addEventListener('scroll', hide, { passive: true, capture: true });
  })();
  // Siegel-Laufband mobil: läuft per scrollLeft, lässt sich wischen, setzt danach fort
  (() => {
    const mq = matchMedia('(max-width: 749px)'); const still = matchMedia('(prefers-reduced-motion: reduce)');
    const run = (el) => {
      if (el.dataset.mqInit) return; el.dataset.mqInit = '1'; el.classList.add('is-js');
      const t = el.querySelector('.cal-seals-mq__t'); let hold = 0; let x = el.scrollLeft;
      const pause = (ms) => { hold = performance.now() + ms; };
      el.addEventListener('touchstart', () => pause(1e9), { passive: true });
      el.addEventListener('touchend', () => pause(2500), { passive: true });
      el.addEventListener('pointerdown', () => pause(1e9));
      el.addEventListener('pointerup', () => pause(2500));
      el.addEventListener('wheel', () => pause(2500), { passive: true });
      const step = (now) => {
        if (!el.isConnected) return;
        // Passen alle Siegel in die Zeile, kein Laufband und keine Kopie (sonst stünde jedes Siegel zweimal sichtbar da)
        const first = t.firstElementChild; const fit = first && first.scrollWidth <= el.clientWidth + 1;
        if (fit !== el.classList.contains('is-fit')) { el.classList.toggle('is-fit', fit); el.scrollLeft = 0; x = 0; }
        if (fit) { requestAnimationFrame(step); return; }
        const half = t.scrollWidth / 2;
        if (mq.matches && !still.matches && now > hold && !el.classList.contains('is-paused') && half > el.clientWidth / 2) {
          x = (now > hold + 16 ? x : el.scrollLeft) + 0.45; el.scrollLeft = x;
        } else { x = el.scrollLeft; }
        if (half > 0 && el.scrollLeft >= half) { el.scrollLeft -= half; x = el.scrollLeft; }
        requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const init = () => { if (mq.matches) document.querySelectorAll('.cal-seals-mq').forEach(run); };
    init(); mq.addEventListener('change', init);
    document.addEventListener('shopify:section:load', init);
  })();

})();

/* Schließen-Buttons in Dialogen per Delegation (funktioniert auch nach Neuaufbau im Editor) */
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-cal-close]'); if (!b) return;
  const d = b.closest('dialog'); if (d && d.open) { e.preventDefault(); d.close(); }
});
